module.exports = __webpack_public_path__ + "media/images/projects/15-dashboard-92589f60ce74907a41bbab567c5159fe.jpg";